<template>
  <div class="column-label" @click="onLabelClick">
    {{ active ? "◀" : "▶" }}
  </div>
  <div class="column" v-if="active">
    <slot></slot>
  </div>
</template>

<script setup>

import { ref } from 'vue';

const active = ref(true)

const onLabelClick = e => {
  active.value = !active.value
}

</script>

<style scroped>
.column-label {
  background-color: #9dc2db;
  user-select: none;
  border: 2px solid black;
}

.column {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin-right: 6px;
}
</style>